module.exports = __webpack_public_path__ + "static/media/trainers-selected.2392bea4.svg";